import { createSelector } from 'reselect';
const authSelect = (state) => state.auth;

export const selectAuth = createSelector([authSelect], (auth) => auth);
export const selectCurrentWorkspace = createSelector(
  [authSelect],
  (auth) => auth.current?.default_workspace
);
export const selectCurrentAdmin = createSelector(
  [authSelect],
  (auth) => auth.current
);
export const permissionUserInWorkspace = createSelector(
  [authSelect],
  (auth) => auth.current?.permissions
);

export const selectCurrentEmail = createSelector(
  [authSelect],
  (auth) => auth.current?.email
);

export const isLoggedIn = createSelector(
  [authSelect],
  (auth) => auth.isLoggedIn
);

/**
 * The platform-plane roles from `/me`, upper-cased: `PLATFORM_OWNER`, `SUPPORT_ADMIN`, or
 * none. Normalised here so every reader compares the same spelling.
 */
export const selectPlatformRoles = createSelector([authSelect], (auth) =>
  (auth.current?.platformRoles || []).map((role) => String(role).toUpperCase())
);

export const selectUserRoles = createSelector(
  [authSelect, selectPlatformRoles],
  (auth, platformRoles) => [...(auth.current?.roles || []), ...platformRoles]
);
export const selectIsLoggedIn = createSelector(
  [authSelect],
  (auth) => auth.isLoggedIn
);
